import React from 'react'
import {
    withRouter
} from 'react-router-dom'
import {
    Row,
    Button,
    Col,
    Modal,
    message,
    InputNumber,
    Form
} from 'antd'
import { IoMdClose } from 'react-icons/io'

class FormCashup extends React.Component {
    constructor() {
        super()
    }
    onCreate = (e) => {
        e.preventDefault()
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.props.onCreate(values)
            }
        })
    }
    render() {
        const { getFieldDecorator } = this.props.form;

        return (
            <div className='wrapperPopupNav'>
                  <i onClick={this.props.onCancel} className="close"><IoMdClose /> </i>
                <p className='title'>Cash up Expected Amount</p>
                {/* <Modal
                    className='popup-cashup'
                    visible={this.props.modalOpen}
                    title="Cash up Expected Amount"
                    footer={false}
                    onCancel={() => this.props.onCancel()}
                    onChange={() => { return }}

                >
                </Modal>  */}
                <div style={{width: "100%"}}>
                    <Form onSubmit={this.onCreate}>
                        <div className='inps'>
                            <Form.Item className='input' label={'Expected card amount'} style={{ width: '100% !important' }} >
                                {getFieldDecorator('card', {
                                    rules: [{ required: true, message: "Please enter card amount" }]
                                })(
                                    <InputNumber placeholder='Expected card amount' style={{ width: '100%' }} />
                                )}
                            </Form.Item>  
                            <Form.Item label={'Expected cash amount'} style={{ width: '100% !important' }} >
                                {getFieldDecorator('cash', {
                                    rules: [{ required: true, message: "Please enter card amount" }]
                                })(
                                    <InputNumber placeholder='Expected cash amount' style={{ width: '100%' }} />
                                )}
                            </Form.Item>  
                        </div>
                       <div className='btns'>
                            <Button type="primary" style={{ margin: '0 10px' }} className="signup-form-button">
                                {'Cancel'}
                            </Button>
                            <Button type="primary" htmlType="submit" style={{ margin: '0 10px' }} className="signup-form-button btnSpacing" >
                                {'Close'}
                            </Button> 
                       </div>
                    </Form>
                </div>
            </div>
        )
    }
}

const WrappedAttributeUpdate = Form.create()(FormCashup);
export default withRouter(WrappedAttributeUpdate);
